import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CircleDotIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { milestones } from '../data/timeline';
export function CareerTimeline() {
  const [active, setActive] = useState(0);
  const milestone = milestones[active];
  return <section id="career" className="scroll-mt-16 bg-white" data-id="element-27" data-mp="3ahdg18466d9a">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-28" data-id="element-28" data-mp="3eifidxtdv5fh">
        <SectionHeading index="III" title="Executive Career Milestones" description="Select a tenure to review scope, mandate, and outcomes." data-id="element-29" data-mp="3jgqqa304b5v2" />

        <div className="mt-14 grid gap-12 lg:grid-cols-[19rem_1fr] lg:gap-16" data-id="element-30" data-mp="3o9tavlmx34z4">
          <div role="tablist" aria-label="Career tenures" aria-orientation="vertical" className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:gap-0 lg:overflow-visible lg:pb-0" data-id="element-31" data-mp="3t5s53puxfh7g">
            {milestones.map((item, i) => {
            const selected = i === active;
            return <button key={item.period} type="button" role="tab" id={`tenure-tab-${i}`} aria-selected={selected} aria-controls="tenure-panel" onClick={() => setActive(i)} className={['focus-ring group relative shrink-0 border-steel-100 px-5 py-4 text-left transition-colors duration-150 ease-exec lg:w-full lg:border-b', selected ? 'bg-canvas' : 'hover:bg-canvas'].join(' ')} data-id="element-32" data-mp="1s32eg97ngvoh" data-mpi={i}>
                  <span aria-hidden="true" className={['absolute left-0 top-0 h-full w-[2px] transition-colors duration-150 ease-exec', selected ? 'bg-bronze' : 'bg-transparent'].join(' ')} data-id="element-33" data-mp="2151x15ybc7tj" />
                  <span className="block whitespace-nowrap text-[11px] font-semibold uppercase tracking-overline text-bronze-600" data-id="element-34" data-mp="rwgkucggh19a">
                    {item.period}
                  </span>
                  <span className={['mt-1.5 block whitespace-nowrap font-serif text-base lg:whitespace-normal', selected ? 'text-navy' : 'text-steel-400'].join(' ')} data-id="element-35" data-mp="i6dny167r35o">
                    {item.organization}
                  </span>
                </button>;
          })}
          </div>

          <AnimatePresence mode="wait" initial={false} data-id="element-36" data-mp="3vd5ptu0e42wu">
            <motion.div key={milestone.period} id="tenure-panel" role="tabpanel" aria-labelledby={`tenure-tab-${active}`} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} className="border-t-2 border-navy pt-8" data-id="element-37" data-mp="45t9fh7bzthz">
              <p className="text-[11px] font-semibold uppercase tracking-overline text-steel-400" data-id="element-38" data-mp="3e44mn8rlzf4d">
                {milestone.period}
              </p>
              <h3 className="mt-4 font-serif text-3xl leading-tight text-navy" data-id="element-39" data-mp="3o19816dmr6k4">
                {milestone.role}
              </h3>
              <p className="mt-2 text-base font-semibold text-bronze-600" data-id="element-40" data-mp="5lyoyizcfxbb">
                {milestone.organization}
              </p>
              <p className="mt-6 max-w-2xl text-base leading-relaxed text-steel-400" data-id="element-41" data-mp="nna1tu6ywm8">
                {milestone.summary}
              </p>
              <ul className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-42" data-mp="aljmqq2s1zmg">
                {milestone.highlights.map(highlight => <li key={highlight} className="flex gap-3 border-t border-steel-200 pt-4" data-id="element-43" data-mp="2hdkd7la7fw5c">
                    <CircleDotIcon className="mt-0.5 h-4 w-4 shrink-0 text-bronze" aria-hidden="true" data-id="element-44" data-mp="2cfskwq5ne80m" />
                    <span className="text-sm leading-relaxed text-navy-700" data-id="element-45" data-mp="18e17mie88f0x">
                      {highlight}
                    </span>
                  </li>)}
              </ul>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}